import type { ResolvedProjectRoute } from './resolveProjectByRouteRef'

import { defineStore } from 'pinia'

import { isUuid } from '~/shared/lib'
import {
  clearSupersededProjectRouteRefs,
  markSupersededProjectRouteRef,
} from './projectRouteBackNavigation'

export const useProjectRouteStore = defineStore('projectRoute', () => {
  const current = ref<ResolvedProjectRoute | null>(null)

  function setResolved(data: ResolvedProjectRoute | null) {
    if (!data) {
      current.value = null
      return
    }

    if (data.projectId !== current.value?.projectId) {
      clearSupersededProjectRouteRefs()
    }

    current.value = data
  }

  function getProjectIdForRef(ref: string | undefined): string {
    if (!ref) {
      return current.value?.projectId ?? ''
    }
    if (current.value?.projectRef === ref) {
      return current.value.projectId
    }
    if (isUuid(ref)) {
      return ref
    }
    return ''
  }

  return {
    current,
    setResolved,
    getProjectIdForRef,
    markSupersededProjectRouteRef,
  }
})
